import React from "react";
import { isoToMdy } from "../utility/favInbox";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// FavGhostTile (#642) — a "ghost" booking: where FAV 2.0 WOULD have put an open FAV
// Inbox job (crew row × advised working day). Advice only, nothing is booked here —
// so it is never draggable and drops nothing; clicking opens the REAL job.
// Rendered by optimizerScreen's crew cells from FavInboxContext.ghostsByCell. UAT-only
// (the Inbox is hidden on production builds).
// TEMPORARY (Leland 2026-10-13): a trial/demo aid for FAV 2.0 — deliberately NOT in the
// user manual. Remove (or rethink) when FAV 2.0 books crews itself.
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

export function ghostTitle(ghost) {
  const conf = ghost.confidence != null ? ` · ${Math.round(ghost.confidence * 100)}% chance that's enough` : "";
  const tail = ghost.adviceOnly
    ? "Advice only: FAV hasn't booked this job — it's still waiting to be scheduled."
    : `Advice only: FAV booked it on ${isoToMdy(ghost.bookedDate)} with no crew.`;
  return `FAV 2.0 would book this job here with ${ghost.crew} — day ${ghost.day} of ${ghost.of}${conf}. ${tail}`;
}

const FavGhostTile = ({ ghost, project, largeView, onOpen }) => {
  const label = project ? (largeView ? project.encodedLargeTitle : project.encodedSmallTitle) : null;
  return (
    <div
      data-fav-ghost={ghost.jobId}
      data-testid="fav-ghost"
      title={ghostTitle(ghost)}
      onClick={() => project && onOpen && onOpen(project)}
      className="text-sm-2 min-h-6 px-2 rounded-sm italic cursor-pointer"
      style={{
        border: "2px dashed rgb(var(--color-button-accent) / 1)",
        background: "rgb(var(--color-button-accent) / 0.08)",
        opacity: 0.9,
      }}
    >
      <span className="font-bold not-italic">FAV 2.0</span> · day {ghost.day} of {ghost.of}
      {label ? <span> · {label}</span> : null}
    </div>
  );
};

export default FavGhostTile;
